import { SET_SATSER, SetSatserAction } from './Types';

export function setSatser<T>(satser: T): SetSatserAction<T> {
    return {
        type: SET_SATSER,
        payload: satser,
    };
}
